import React from "react";
import RemarkRenderer from "components/RemarkRenderer";
import RemarkContext from "components/RemarkRenderer/RemarkContext";

function RichText(props) {
  const { content } = props;
  const { align, color, gradientColor } = content;

  return (
    <RemarkContext.Provider value={{ align, color, gradientColor }}>
      <RemarkRenderer
        editable
        ast={content.content.childMarkdownRemark?.htmlAst}
      />
    </RemarkContext.Provider>
  );
}

export default RichText;
